<template>
    <div class="detailbox">
        <div class="mkbox">
            <div @click="returnpage" class="returnbtn" v-if="isApp"><i class="el-icon-arrow-left"></i></div>
            <div class="detaitit" v-if="info.name">
                {{info.name}}-{{info.days}}{{$t('index.day')}}
            </div>
            <div class="flexbox fle-sb fle-wrap">
                <div class="itembox">
                    <div class="flexbox fle-sa tipitem">
                        <img :src="info.image">
                        <div>
                            <div class="apptit">{{info.name}}</div>
                            <div>{{info.days}}{{$t('index.day')}}</div>
                        </div>
                        <div class="colory">{{info.price}}</div>
                        <div class="apprig">
                            <div class="appcolorg">{{info.rate}}%</div>
                            <div>{{$t('index.unit')}}</div>
                        </div>
                    </div>
                </div>
            </div>
            <el-form :model="form" :rules="rules" ref="form" label-width="340px" class="demo-ruleForm">
                <el-form-item class="labeltit" :label="$t('index.product_num_min')+info.min_count+')'" prop="">
                    <el-input prefix-icon="el-icon-user-solid" v-model="form.product_num"
                              :placeholder="$t('index.input_product_num')"
                              type="number"
                              autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item :label="$t('account.trader_password')" prop="">
                    <el-input prefix-icon="el-icon-key" type="password" v-model="form.pay_password"
                              :placeholder="$t('account.input_trader_password')"
                              autocomplete="off"></el-input>
                </el-form-item>
                <!--<div class="" @click="jumptoarticle()"><el-checkbox class="checkr" v-model="checked"></el-checkbox>{{$t('product.agreement')}}</div>-->
                <div class="btnn bybtn" type="primary" @click="submitForm()">{{$t('index.buy')}}</div>

            </el-form>
        </div>
    </div>
</template>

<script>
    // @ is an alias to /src
    import {getInfo, addOrder} from '@/api/product'

    export default {
        name: 'detail_box',
        data() {
            return {
                id: this.$route.params.id,
                info: {
                    name: '',
                    price: '0.00',
                    days: '0',
                    rate: '0',
                    min_count: '0',
                },
                form: {
                    product_id: this.$route.params.id,
                    product_num: null,
                    pay_password: ''
                },
                rules: {
                    product_num: [
                        {required: true, message: '', trigger: 'blur'}
                    ],
                    pay_password: [
                        {required: true, message: '', trigger: 'blur'}
                    ],
                },
                checked: true,

            }
        },
        computed: {
            isApp() {
                return document.documentElement.clientWidth < 800 ? true : false
            },
            routeName() {
                console.log(this.$route.path)
                return this.$route.path
            }
        },
        created() {
            this.getData()
        },
        methods: {
            getData() {
                getInfo({id: this.id}).then(res => {
                    console.log(res)
                    const data = res.data
                    this.info = data.data
                    this.money = data.money

                }).catch(_ => {

                })
            },
            jumptoarticle() {
                this.$router.push({path: '/article/1'})
            },
            returnpage() {
                this.$router.go(-1)
            },
            submitForm() {
                if (this.form.product_num == "" || this.form.product_num == null) {
                    this.$message.error(this.$t('index.input_product_num'))
                    return false
                }
                if (Number(this.form.product_num) < Number(this.info.min_count)) {
                    this.$message.error(this.$t('index.input_product_num_min') + this.info.min_count)
                    return false
                }
                if (this.form.pay_password == "") {
                    this.$message.error(this.$t('account.input_your_trader_password'))
                    return false
                }
                if (!this.checked) {
                    this.$message.error(this.$t('product.agreement_tip'))
                    return false
                }
                this.submit()
            },
            submit() {
                let params = {...this.form}
                let that = this
                addOrder(params).then(res => {
                    if (res.code == 1) {
                        this.$message.success(res.msg)
                        setTimeout(function () {
                            that.$router.replace('/home/myMoneyManage')
                        }, 1000);
                    } else {
                        this.$message.error(res.msg)
                    }

                }).catch(_ => {

                })

            },
        }
    }
</script>
<style lang="scss" scoped>
    .detailbox {
        width: 1200px;
        margin: 20px auto;
        min-height: calc(100vh - 290px);

        .checkr {
            margin-right: 10px;
        }

        .detaitit {
            position: relative;
            padding: 20px;
            width: fit-content;
            margin: 20px auto;
            font-size: 60px;

            &::before {
                content: '';
                width: 200px;
                height: 2px;
                background: #fff;
                position: absolute;
                left: -240px;
                top: 60px;
            }

            &::after {
                content: '';
                width: 200px;
                height: 2px;
                background: #fff;
                position: absolute;
                right: -240px;
                top: 60px;
            }


        }

        .bybtn {
            width: 100%;
            margin: 20px auto;
            text-align: center;
            line-height: 60px;
            background: rgb(23, 92, 240);
        }

        .el-checkbox {
            color: #fff;
            text-align: left;
            font-size: 20px;
        }

        .itembox {
            padding: 20px;
            margin: 20px 0px;
            width: 100%;
            box-sizing: border-box;
            border-radius: 10px;
            background: rgb(36, 36, 36);
            font-size: 30px;
            text-align: left;

            img {
                padding: 0px 20px 20px 0px;
                width: 100px;
                height: 100px;
            }

            .tipitem {
                & > div {
                    margin: 20px 20px;
                }
            }
        }
    }
</style>
